import React from "react";
import ReactDOM from "react-dom/client";

import "framework7/css/bundle";
import './core/css/app.css';

import Framework7 from "framework7/lite-bundle";
import Framework7React from "framework7-react";
import { AuthProvider } from "./modules/auth/AuthProvider";
import MyApp from "./App";

Framework7.use(Framework7React);

ReactDOM.createRoot(document.getElementById("root")).render(
    <AuthProvider>
        <MyApp />
    </AuthProvider>
);
